/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetItemsQuery } from '../../models/get-items-query';
import { GetItemsQueryResult } from '../../models/get-items-query-result';

export interface ApiNurseryManagerItemsGetItemsPost$Plain$Params {
      body?: GetItemsQuery
}

export function apiNurseryManagerItemsGetItemsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerItemsGetItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerItemsGetItemsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetItemsQueryResult>;
    })
  );
}

apiNurseryManagerItemsGetItemsPost$Plain.PATH = '/api/NurseryManager/Items/GetItems';
